/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
import helper from '@/_libs/helper';

const auth = {
  async login(username, password, token) {
    // await new Promise(resolve => setTimeout(resolve, 1200)); // TODO: remove this in prod
    // if (password === 'wrong') throw new Error(); // TODO: remove this in prod
    return await helper.call('auth.login', {
      success: true,
    }, async () => await axios.post(helper.path('auth/login/'), {
      username,
      password,
      token,
    }));
  },
  async logout() {
    return await helper.call('auth.logout', {
    }, async () => await axios.post(helper.path('auth/logout/')));
  },
};

export default auth;
